<template>
	<div class="home">
		<!-- 顶部欢迎及注册登录按钮导航 -->
		<header-top />
		<!-- 顶部公司logo及导航栏 -->
		<logo-head></logo-head>
		<!-- 导航栏 -->
		<NavHead></NavHead>
		<!-- 横幅 -->
		<div class="vBanner">
			<img src="../../assets/img/basicServices/basic_service.jpg">
		</div>
		<!-- 主体内容 -->
		<div class="basicServive">
			<div class="serviceContent">
				<!-- 精选服务 -->
				<div class="selectServices">
					<!-- title -->
					<div class="title">
						<span>精选服务</span>
						<!-- 装饰条 -->
						<div class="bottomIcon">
						</div>
					</div>
					<!-- 列表 -->
					<div class="selectServiceList">
						<!-- 卡片 -->
						<div class="cardList" v-for="(item,index) in selectSeviceArr" :key="index" 
						@click="goDetailLink(item.id,'精选服务','/basicServices','base')">
							<!-- 左侧名称及价格 -->
							<div class="leftName">
								<!-- 名称 -->
								<div class="name">
									{{item.name.length > 10 ? item.name.substr(0,10) + '...' : item.name}}
								</div>
								<!-- 价格 -->
								<div class="price">
									￥{{item.chargeAmount}}
								</div>
							</div>
							<!-- 右侧图标 -->
							<div class="rightIcon">
								<img :src="item.logoUrl" width="60" height="60">
							</div>
						</div>
					</div>
				</div>
				<!-- 常用服务 -->
				<ModuleTitle titleName="常用服务·" titleEngName="Common services" titleLastName="专利" class="pt-4"></ModuleTitle>
				<!-- 常用专利 -->
				<div class="usePatent">
					<!-- 卡片列表 -->
					<serviveCard :topName="item.name" :price="item.chargeAmount"  v-for="(item,index) in usePatentArr" :key="index"
					:logoUrl="item.logoUrl">
						<span class="contentBtn"  @click="goDetailLink(item.id,item.baseServeType,'/serviceList?index=1','base')">
							查看详情
						</span>
					</serviveCard>
				</div>
				<!-- 更多专利服务 -->
				<div class="morePatent" @click="moreLink('/serviceList',1)">
					更多专利服务>
				</div>
				<!-- 常用服务-商版 -->
				<ModuleTitle titleName="常用服务·" titleEngName="Common services" titleLastName="商版" class="pt-4"></ModuleTitle>
				<!-- 常用商版 -->
				<div class="usePatent">
					<!-- 卡片列表 -->
					<serviveCard :topName="item.name" :price="item.chargeAmount"  v-for="(item,index) in useBrandArr" :key="index" 
					:logoUrl="item.logoUrl">
						<span class="contentBtn" @click="goDetailLink(item.id,item.baseServeType,'/serviceList?index=2','base')">
							查看详情
						</span>
					</serviveCard>
				</div>
				<!-- 更多专利服务 -->
				<div class="morePatent" @click="moreLink('/serviceList',2)">
					更多商版服务>
				</div>
			</div>
		</div>
		<!-- 底部导航 -->
		<div>
			<Footer :bgColor="'#fafafa'" :border="true"></Footer>
		</div>
	</div>
</template>

<script>
	import {
		ref,
	} from 'vue'
	import HeaderTop from '@/components/headerTop/headerTop.vue'
	import LogoHead from '@/components/logoHead/logoHead.vue'
	import NavHead from '@/components/navHead/navHead.vue'
	import ModuleTitle from '@/components/moduleTitle/moduleTitle.vue'
	import PopularTab from '@/components/popularTab/popularTab.vue'
	import showCard from '@/components/showCard/showCard.vue'
	import serviveCard from '@/components/showCard/serviceCard.vue'
	import Footer from '@/components/footer/footer.vue'
	import { Collection } from '@element-plus/icons'
	export default {
		name: 'Home',
		components: {
			HeaderTop,
			LogoHead,
			NavHead,
			ModuleTitle,
			PopularTab,
			showCard,
			serviveCard,
			Footer,
			Collection
		},
		setup() {
			let selectSeviceArr = ref([])
			let usePatentArr = ref([])
			let useBrandArr = ref([])
			return {
				selectSeviceArr,
				usePatentArr,
				useBrandArr
			}
		},
		mounted() {
			this.getSelectSevice()
			this.getUsePatentData()
			this.getUseBrandData()
		},
		methods: {
			// 获取精选服务数据
			getSelectSevice(){
				let vm = this
				vm.axios.get('/api/base/serve/findBoutique').then(res => {
					console.log(res)
					vm.selectSeviceArr = res.data.data
				})
			},
			// 获取常用服务-专利数据
			getUsePatentData(){
				let vm = this
				vm.axios.get('/api/base/serve/findPatentServeAndCommon').then(res => {
					vm.usePatentArr = res.data.data
				})
			},
			// 获取常用服务-商标数据
			getUseBrandData(){
				let vm = this
				vm.axios.get('/api/base/serve/findBrandServeAndCommon').then(res => {
					vm.useBrandArr = res.data.data
				})
			},
			// 进入商品详情页
			goDetailLink(id,mbx,mbxLink,type){
				let routeData = this.$router.resolve({
					path:'/goodsInfo',
					query:{
						id:id,
						mbx:mbx,
						mbxLink:mbxLink,
						type:type
					}
				})
				window.open(routeData.href, '_blank');
			},
			// 更多服务页面
			moreLink(linkUrl,index){
				let routeData = this.$router.resolve({
					path:linkUrl,
					query:{
						index
					}
				})
				window.open(routeData.href, '_blank');
			}
		},
	}
</script>
<style scoped>
	.vBanner {
		width: 100%;
		height: 300px;
		overflow: hidden;
	}

	/* 主体内容 */
	.basicServive {
		width: 100%;
		min-height: 800px;
		overflow: hidden;
		background-color: #f8f8f8;
	}

	.basicServive .serviceContent {
		width: 1200px;
		min-height: 800px;
		margin: 0 auto;
		margin-top: 20px;
		margin-bottom:60px;
	}

	/* 精选服务 */
	.basicServive .serviceContent .selectServices {
		width: 1200px;
		height: 250px;
		background-color: #fff;
	}

	/* 精选服务-标题 */
	.basicServive .serviceContent .selectServices .title {
		width: 80px;
		margin: 0 auto;
		position: relative;
		top: 15px;
	}

	/* 装饰条 */
	.basicServive .serviceContent .selectServices .title .bottomIcon {
		width: 60px;
		height: 7px;
		background-color: orange;
		position: absolute;
		left: -10px;
	}

	.basicServive .serviceContent .selectServices .title span {
		font-size: 20px;
		font-weight: bold;
	}

	/* 精选服务列表 */
	.basicServive .serviceContent .selectServices .selectServiceList {
		width: 1100px;
		height: 150px;
		margin: 0 auto;
		margin-top:40px;
		display: flex;
		justify-content: space-between;
	}

	.basicServive .serviceContent .selectServices .selectServiceList .cardList {
		width:260px;
		height: 150px;
		border: 1px solid #eee;
		display: flex;
		cursor: pointer;
	}

	/* 左侧名称及价格 */
	.basicServive .serviceContent .selectServices .selectServiceList .cardList .leftName {
		margin-top: 20px;
		width: 160px;
		padding: 15px;
	}

	.basicServive .serviceContent .selectServices .selectServiceList .cardList .leftName .name {
		font-size: 16px;
	}

	.basicServive .serviceContent .selectServices .selectServiceList .cardList .leftName .price {
		font-size: 18px;
		color: #C32A1A;
		font-weight: bold;
		margin-top:20px;
	}
	/* 右侧图标 */
	.basicServive .serviceContent .selectServices .selectServiceList .cardList .rightIcon{
		width:100px;
		text-align: center;
		line-height:130px;
	}
	/* 常用专利 */
	.usePatent{
		width: 1200px;
		min-height:200px;
		margin-top:30px;
		margin-bottom: 20px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	/* 更多专利服务 */
	.morePatent{
		width:170px;
		height: 46px;
		border: 1px solid #ff7800;
		color: #ff7800;
		border-radius: 5px;
		font-size: 14px;
		text-align: center;
		line-height: 46px;
		margin: 0 auto;
		cursor: pointer;
	}
	/* 查看详情 */
	.contentBtn{
		width: 60px;
		margin-right: 10px;
		color: #999;
		cursor: pointer;
	}
	.contentBtn:hover{
		color: #C32A1A;
	}
</style>
